import script from "./alert-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./alert-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./alert-setting-ly.vue?vue&type=style&index=0&id=6fd652b0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fd652b0"]])

export default __exports__